import { formatIconImg, formatImgSng, formatTags } from './formatters';
import { formatSngAttr } from './formatters/attributes';
import { RPGLink, RPGTypes } from './formatters/types';
import type { Options, PokerGameTile, SngType } from './types';

const mapSngType = (
  {
    id,
    clubId,
    buyIn,
    currency,
    game,
    isHiLo,
    minPlayers,
    maxPerTable,
    rake,
    satelliteTarget,
    server,
    serverObj,
    speedDisplay,
    structure,
    tournGroup,
    lastEntry,
    tournFlags2,
    tournFlags,
    maxPlayers,
    isPlayMoney,
    scalePM,
    prizes,
    awardScheme,
    timedTournType,
    timedTournPlayersPercent
  }: SngType,
  { language }: Options
): PokerGameTile => ({
  id,
  clubId,
  type: RPGTypes.SNG,
  link: RPGLink.SNG,
  imageUrl: formatImgSng(
    game,
    structure,
    buyIn,
    isHiLo,
    satelliteTarget,
    tournGroup,
    maxPerTable,
    tournFlags2
  ),
  imageUrlV2: formatImgSng(
    game,
    structure,
    buyIn,
    isHiLo,
    satelliteTarget,
    tournGroup,
    maxPerTable,
    tournFlags2,
    true
  ),
  tags: formatTags({
    game,
    structure,
    minPlayers,
    maxPlayers,
    maxPerTable,
    tournGroup,
    satelliteTarget,
    tournFlags,
    tournFlags2,
    speedDisplay,
    awardScheme,
    timedTournType,
    timedTournPlayersPercent,
    isHiLo: Boolean(isHiLo)
  }),
  attributes: formatSngAttr(
    { buyIn, rake, currency, maxPlayers, isPlayMoney, scalePM, prizes },
    language
  ),
  iconUrl: formatIconImg(RPGTypes.SNG),
  lastEntry,
  server,
  serverObj
});

const mapSngTypeFn = (sngTypes: SngType[], options: Options): PokerGameTile[] =>
  sngTypes.map((type) => mapSngType(type, options));

export default mapSngTypeFn;
